import Skeleton from "react-loading-skeleton";

import { GoogleAccountHandleSkeleton } from "../GoogleAccountHandleSkeleton";

export const ConnectedAccountRowSkeleton = () => {
  return (
    <tr>
      <td>
        <GoogleAccountHandleSkeleton />
      </td>
      <td>
        <Skeleton height={22} width={22} />
      </td>
    </tr>
  );
};
